<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">

        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">{{pageTitle}}</div>
                    <button type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click="BackButton()"><span>Back</span></button>
                </div>
                <!--Forms-->
                <form>
                    <div class="forms-container">
                        <div class="row no-margin">
                            <div class="col-12 forms-block common-disable">
                                <div class="common-form-field">
                                    <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                        <div class="form-label">Group Name :</div>
                                    </div>

                                    <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                        <input type="text" v-validate="'required'" class="form-control" v-model="group_title" id="group_title" placeholder="Enter Group Name" name="group_title">
                                        <span v-show="errors.has('group_title')" class="help is-danger">The Name is Required.</span>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <button :disabled="buttonDisable" type="submit" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="BackButton()" value="Cancel"><span>Cancel</span></button>
                                <button :disabled="buttonDisable" type="submit" id="createAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="saveGroup('save-and-continue')" value="Save and Continue" v-if="editId == 0"><span>{{saveContinueButtonTitle}}</span></button>
                                <button :disabled="buttonDisable" type="submit" id="createAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="saveGroup('save')" value="Save"><span>{{saveButtonTitle}}</span></button>
                            </div>
                        </div>
                    </div>
                </form>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import {commonMixins} from '../mixins/commonMixins';
    import {HTTP} from '../http-common.js';
    /* https://github.com/xiaokaike/vue-color */
    import { Chrome } from 'vue-color';

    export default {
        name: 'AddAttachmentGroup',
        mixins: [commonMixins],
        components: {
            'app-footer': Footer,
            'chrome-picker': Chrome,
        },
        data() {
            return {
                editId: 0,
                saveButtonTitle: "Save",
                saveContinueButtonTitle: "Save And Continue",
                pageTitle: "Add Attachment Group",
                group_title: "",
                selectColorBtnTitle: 'Click To Select Color',
                hideColorPicker: true,
                buttonDisable: false,
                colors: {
                    hex: "#444444",
                    hex8: "#444444",
                },
            }
        },
        created: function () {

        },
        mounted: function () {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[2] == 'edit') {
                self.pageTitle = "Edit Attachment Group";
                self.editId = (segments[3] === null || typeof segments[3] === "undefined") ? 0 : segments[3];
                self.saveButtonTitle = (segments[3] === null || typeof segments[3] === "undefined") ? "Save" : "Update";
                self.loadGroups();
            }
            //$('.common-disable :input').attr('disabled', true);
        },
        methods: {
            BackButton: function () {
                var self = this;
                self.$router.push('/attachment-group/list');
            },
            loadGroups: function () {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    params: {
                        'id': self.editId,
                    }
                };
                self.showLoader();
                HTTP.get("attachment_group_list", config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            self.group_title = response.data.content[0].text;
                            self.$nextTick(function () {
                                self.colors = JSON.parse(response.data.content[0].color_code_obj);
                            });
                        }
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        self.catchHandler(err, function () {});
                        self.BackButton();
                    });
            },
            saveGroup: function (flag) {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                var fields = {group_title: self.group_title, color_code: JSON.stringify(self.colors),}
                if (segments[2] == 'edit') {
                    fields.id = segments[3];
                }
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        self.showLoader();
                        if (flag == 'save-and-continue') {
                            self.saveContinueButtonTitle = "Saving...";
                        } else {
                            self.saveButtonTitle = (self.editId == 0) ? "Saving..." : "Updating...";
                        }
                        self.buttonDisabl = true;
                        HTTP.post('savegroup', fields, config)
                            .then(function (response) {
                                self.buttonDisabl = false;
                                self.saveButtonTitle = (self.editId == 0) ? "Save" : "Update";
                                self.saveContinueButtonTitle = "Save And Continue";
                                if (response.data.status == "success") {
                                    self.showSAlert(response.data.message, 'success');
                                    if (flag == 'save-and-continue') {
                                        self.group_title = '';
                                        self.colors.hex8 = "#000000";
                                        self.colors.hex = "#000000";
                                    } else {
                                        self.BackButton();
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.buttonDisabl = false;
                                self.saveButtonTitle = (self.editId == 0) ? "Save" : "Update";
                                self.saveContinueButtonTitle = "Save And Continue";
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                                self.BackButton();
                            });

                    }
                });
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            }
        }
    };
</script>